/* @flow */
import * as React from 'react';
import Image from 'components/Image';
import Link from 'components/Link';
import ModalTrigger from 'components/ModalTrigger';
import SupportDialog from 'support/components/SupportDialog';
import { withDocumentTitle } from 'lib/documentTitle';
import EventTracking from 'lib/EventTracking';
import qs from 'qs';

import './styles/BrokenShareButtonPage.scss';

type Props = {
  location: Object,
};

class BrokenShareButtonPage extends React.Component<Props> {
  componentDidMount() {
    const { location } = this.props;
    // Extract params from location.query
    const { reason, path, referrer, url } = (() => {
      if (location && location.query && location.query.path && location.query.reason) {
        const queryParams = qs.parse(location.query.path.replace('?', ''));
        return {
          reason: location.query.reason,
          path: location.query.path,
          referrer: queryParams['referrer'],
          url: queryParams['url'],
        };
      } else {
        return {
          reason:
            "there was a problem with the share link, but the information about the problem wasn't properly passed to this page (an internal error occurred).",
          path: '',
          referrer: '',
          url: '',
        };
      }
    })();
    // Print out a message for 3rd parties to debug
    console.log(
      '=======================================================================================\n' +
        '\n' +
        'Share on Remind link was invalid: ' +
        reason +
        '\n' +
        'View our share button docs here: http://engineering.remind.com/developers-site/api.html\n' +
        '\n' +
        '======================================================================================='
    );
    // Track that this happened
    EventTracking.track('share_on_remind.broken_share', {
      data: reason + ', original url: ' + path,
      referrer,
      url,
    });
  }

  render() {
    return (
      <div className="BrokenShareButtonPage">
        <div className="BrokenShareButtonPage-content">
          <Image
            className="BrokenShareButtonPage-image"
            src={require('assets/images/emoji-grin.svg')}
            alt="This is embarrassing"
          />

          <div className="BrokenShareButtonPage-title">Uh oh! This share button is broken.</div>
          <div className="BrokenShareButtonPage-subtext">
            <Link
              to="/classes"
              className="BrokenShareButtonPage-link"
              eventElementName="BrokenShareButtonPage-link">
              Go to your classes
            </Link>
            <span> or </span>
            <ModalTrigger modal={<SupportDialog />}>
              <Link
                className="BrokenShareButtonPage-link"
                eventElementName="BrokenShareButtonPage-link">
                get help
              </Link>
            </ModalTrigger>
            .
          </div>
        </div>
      </div>
    );
  }
}

export default withDocumentTitle('Share button broken', BrokenShareButtonPage);
